<template>
  <div id="warning">
    <!-- 删选 -->
    <div class="searchWarp">
      <div class="searchBox dateBox">
        <el-date-picker v-model="selectDayWarning" :end-placeholder="$t('AllDevices.endDate')" :range-separator="$t('AllDevices.to')" :start-placeholder="$t('AllDevices.startDate')" type="daterange" @change="changeGlobalSearch('date')" />
      </div>
      <SearchCompany v-model="selectCompany2" :value="selectCompany2" @change="changeGlobalSearch" />
      <el-autocomplete v-model="site" class="searchBox" :fetch-suggestions="querySearchCity" :placeholder="$t('dashboard.SiteName')" @select="changeGlobalSearch">
        <el-button slot="append" icon="el-icon-search" @click="changeGlobalSearch" />
      </el-autocomplete>
    </div>
    <div class="containerWarp">
      <!-- 柱状图 -->
      <div style="height: 300px;">
        <bar-chart-two :bar-data="barData" />
      </div>
      <!-- 表格删选 -->
      <div class="searchWarp" style="margin-top: 20px;">
        <!-- 消息类型选择 -->
        <el-select v-model="inforType" :placeholder="$t('AllDevices.Type')" class="searchBox" clearable filterable @change="tableSearch">
          <el-option v-for="(item,index) in inforTypeOptions" :key="index" :label="item.label" :value="item.key" />
        </el-select>
        <el-select v-model="status" :placeholder="$t('AllDevices.Status')" class="searchBox" clearable filterable @change="tableSearch">
          <el-option v-for="(item,index) in statusOptions" :key="index" :label="item.label" :value="item.key" />
        </el-select>
        <div class="searchBox">
          <el-input v-model="inputDeviceName" :placeholder="$t('AllDevices.SearchDeviceNameOrSn')" class="input-with-select" clearable>
            <el-button slot="append" icon="el-icon-search" @click="tableSearch" />
          </el-input>
        </div>
        <el-button v-if="$store.state.userInfo.guestFlag!=true" icon="el-icon-download" type="primary" style="float: right;" @click="download" />
      </div>
      <!-- 表格 -->
      <el-table v-loading="loading" :data="tableData" :default-sort="{prop: 'date', order: 'descending'}" border style="width: 100%">
        <el-table-column :label="$t('warningPage.CreatedAt')" align="center" min-width="10%" prop="createTime" sortable />
        <el-table-column :label="$t('dashboard.DeviceName')" align="center" min-width="15%" prop="deviceName">
          <template slot-scope="scope">
            <p v-if="scope.row.dtype!=1" type="primary">{{ scope.row.deviceName }}</p>
            <el-link v-else type="primary" @click="goToWarningSet(scope.row.mcuId)">{{ scope.row.deviceName }}</el-link>
          <!-- <p @click="goToWarningSet(scope.row.mcuId)">{{ scope.row.deviceName }}</p> -->
          </template>
        </el-table-column>
        <el-table-column :label="$t('warningPage.Content')" min-width="25%" prop="message">
          <template slot-scope="scope">
            <p style="text-align: center;">
              {{ scope.row.message }}
              <span v-if="scope.row.msgType==4" style="color:red;">{{ $t('warningInfo.LevelWarn1') }}</span>
              <span v-else-if="scope.row.msgType==11" style="color:red;">{{ $t('warningInfo.LevelWarn2') }}</span>
              <span v-else-if="scope.row.msgType==12" style="color:red;">{{ $t('warningInfo.LevelWarn3') }}</span>
              <span v-else-if="scope.row.msgType==13" style="color:red;">{{ $t('warningInfo.LevelWarn4') }}</span>
            </p>
          </template>
        </el-table-column>
        <el-table-column :label="$t('AllDevices.Status')" align="center" min-width="10%" prop="status" />
        <el-table-column :label="$t('warningPage.SovledAt')" align="center" min-width="10%" prop="updateTime" sortable />
        <el-table-column :label="$t('BondOrUpdateDevice.OwnedCompany')" align="center" min-width="15%" prop="companyName" />
        <el-table-column :label="$t('warningInfo.AlarmDuration')" align="center" min-width="10%" prop="warnDuration" />
        <el-table-column :label="$t('warningInfo.WorkStatus')" align="center" min-width="10%" prop="WorkStatusZh" />
        <el-table-column :label="$t('yhubReport.Operating')" align="center" min-width="10%" prop="action">
          <template slot-scope="scope">
            <div style="text-align: center;">
              <el-button v-if="$store.state.userInfo.guestFlag!=true" icon="el-icon-edit " size="mini" type="primary" @click="edit(scope.row)" />
            </div>
          </template>
        </el-table-column>
      </el-table>
      <!-- 列表模块————分页 -->
      <div style="background-color: white;width: 100%;border-radius: 0 0 10px 10px;">
        <div class="pagination-container">
          <el-pagination v-if="pageshow" :page-size="listQuery.pageInfo.limit" :page-sizes="listQuery.pageInfo.pageList" :total="listQuery.pageInfo.total" background current-page.sync="listQuery.pageInfo.page" layout="total, sizes, prev, pager, next, jumper" @current-change="handleCurrentChange" @size-change="handleSizeChange" />
        </div>
      </div>
    </div>

    <!-- 编辑--弹窗 -->
    <el-dialog :close-on-click-modal="false" :visible.sync="tableEditPopShow" width="60%">
      <el-form :inline="false" :model="tableRow" label-position="right" label-width="150px">
        <el-form-item :label="$t('warningPage.SovledAt')" prop="mm">
          <el-input v-model="tableRow.updateTime" :disabled="true" style="width: 80%" />
        </el-form-item>
        <!-- </el-form>
        <el-form :model="tableRow" label-position="right" label-width="150px" :inline="false">-->
        <el-form-item :label="$t('BondOrUpdateDevice.OwnedCompany')" prop="mm">
          <el-input v-model="tableRow.companyName" :disabled="true" style="width: 80%" />
        </el-form-item>
        <!-- </el-form>
        <el-form :model="tableRow" label-position="right" label-width="150px" :inline="false">-->
        <el-form-item :label="$t('dashboard.DeviceName')" prop="mm">
          <el-input v-model="tableRow.deviceName" :disabled="true" style="width: 80%" />
        </el-form-item>
        <!-- </el-form>
        <el-form :model="tableRow" label-position="right" label-width="150px" :inline="false">-->
        <el-form-item :label="$t('warningPage.Content')" prop="mm">
          <el-input v-model="tableRow.message" :disabled="true" style="width: 80%" />
        </el-form-item>
        <!-- </el-form>
        <el-form :model="tableRow" label-position="right" label-width="150px" :inline="false">-->
        <el-form-item :label="$t('AllDevices.Status')" prop="mm">
          <el-select v-model="tableRow.status" :placeholder="$t('AllDevices.Status')" class="filter-item" clearable filterable style="width: 80%" @change="changeStatus">
            <el-option v-for="(item,index) in statusOptions" :key="index" :label="item.label" :value="item.key" />
          </el-select>
        </el-form-item>
        <!-- </el-form>
        <el-form :model="tableRow" label-position="right" label-width="150px" :inline="false">-->
        <el-form-item :label="$t('warningPage.Remark')" prop="mm">
          <el-input v-model="tableRow.remark" :autosize="{ minRows: 4, maxRows: 8}" :placeholder="$t('warningSet.Pleaseenter')" style="width: 80%" type="textarea" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="tableEditPopShow = false">{{ $t('button.Cancel') }}</el-button>
        <el-button class="filter-item" type="primary" @click="submitPop">{{ $t('button.Submit') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { findWarningStatisticByScope, listWarningPushMsg2, updatePushMsgDelFlag, exportWarningPushMsgCsv } from '@/api/warning'
import { getCompanySiteList } from '@/api/allDevice'
import BarChartTwo from '@/components/BarChartTwo'
import { getDateAndHour, usedTime } from '@/utils/updateTime.js'
import { pagination } from '@/utils/init_table' // 分页
import { parseTime } from '@/utils'
import i18n from '@/i18n'
import { arrObjSort } from '@/utils/arrayFun.js'
import vPinyin from '@/utils/pinyin-vue.js'
import { temChangeUnit } from '@/utils/temChange.js'

export default {
  name: 'DashboardAdmin',
  components: {
    BarChartTwo
  },
  data() {
    return {
      oneWeek: [new Date().setHours(0, 0, 0, 0) - 6 * 24 * 60 * 60 * 1000, new Date().setHours(0, 0, 0) + 24 * 60 * 60 * 1000 - 1000], // 一周
      selectDayWarning: [new Date().setHours(0, 0, 0, 0) - 6 * 24 * 60 * 60 * 1000, new Date().setHours(0, 0, 0) + 24 * 60 * 60 * 1000 - 1000], // 起始日期,默认一周
      selectDayTable: [], // 起始日期--表格,
      selectCompany: [],
      selectCompany2: [],
      allCity: [],
      site: null, // 公司选择--地名
      tableData: [], // 表格
      // inforTypeOptions: [ // 消息类型选择下拉框数据--表格
      //   { key: 1, label: 'SOC' },
      //   { key: 2, label: '液位' },
      //   { key: 4, label: '温度' },
      //   { key: 5, label: 'SOH' },
      //   { key: 6, label: '位置' },
      //   { key: 7, label: '电压' }],
      inforType: null, // 消息类型选择--表格
      statusOptions: [
        // 状态选择下拉框数据--表格
        { key: 0, label: '未解决' },
        { key: 1, label: '已解决' }
      ],
      status: null, // 状态选择--表格
      barData: [], // 柱状图数据
      inputDeviceName: '', // 设备名称/sn搜索
      // 分页----start
      listQuery: {
        deviceVersion: null,
        pageInfo: pagination(),
        q: ''
      },
      pageshow: true,
      // 分页----end

      tableEditPopShow: false,
      tableRow: {},
      myStatus: null,
      loading: true
    }
  },
  computed: {
    language() {
      return this.$store.state.language
    },
    inforTypeOptions() {
      return [
        // 消息类型选择下拉框数据--表格
        { key: 1, label: 'SOC' },
        { key: 2, label: i18n.t('warningPage.Level') },
        { key: 4, label: i18n.t('basicinfo.HighTemperature') },
        { key: 5, label: 'SOH' },
        { key: 6, label: i18n.t('warningPage.Geofence') },
        { key: 7, label: i18n.t('basicinfo.LowVoltage') },
        { key: 8, label: i18n.t('basicinfo.LowTemperature') },
        { key: 9, label: i18n.t('basicinfo.AbnormalTemperature') },
        { key: 10, label: i18n.t('basicinfo.HighVoltage') },
        // { key: 14, label: i18n.t('warningInfo.secondVolLow') },
        { key: 15, label: i18n.t('warningInfo.HalfVWarnS') },
        { key: 16, label: i18n.t('warningInfo.NetworkAbnormal') },
        { key: 17, label: i18n.t('warningInfo.linChargeOver') },
        { key: 18, label: i18n.t('warningInfo.dataService') },
        { key: 20, label: i18n.t('warningSet.chargeDisAbnormal') },
        { key: 21, label: i18n.t('warningInfo.unitVLow') }
      ]
    }
  },
  watch: {
    language(newValue, oldValue) {
      this.queryList()
      this.queryTable()
    },
    $route() {
      if (this.$route.query.site) { this.site = this.$route.query.site; this.selectCompany2 = []; this.status = 0 }
      if (this.$route.query.companyId) { this.selectCompany2 = [Number(this.$route.query.companyId)]; this.site = ''; this.status = 0 }
      this.queryList()
      // this.tableSearch()
      this.queryTable()
      this.getCity()
    }
  },
  mounted() {
    if (this.$route.query.site) { this.site = this.$route.query.site; this.status = 0 }
    if (this.$route.query.companyId) { this.selectCompany2 = [Number(this.$route.query.companyId)]; this.status = 0 }
    this.queryList()
    // this.tableSearch()
    this.queryTable()
    this.getCity()
  },
  created() {},
  methods: {
    queryList() {
      var param = {
        companyIdList: this.selectCompany,
        site: this.site,
        endDate: new Date(this.oneWeek[1]).getTime(),
        startDate: new Date(this.oneWeek[0]).getTime()
      }
      if (this.selectDayWarning && this.selectDayWarning.length > 0) {
        param.startDate = new Date(this.selectDayWarning[0]).setHours(0, 0, 0, 0)
        param.endDate = new Date(this.selectDayWarning[1]).setHours(0, 0, 0, 0) + 24 * 60 * 60 * 1000 - 1000
      }
      findWarningStatisticByScope(param).then(res => {
        // 柱状图数据
        if (res.resultCode === 1001) {
          this.barData = []
          this.barData = res.resultModel
        }
      })
    },
    queryTable() {
      this.statusOptions[0].label = i18n.t('warningPage.Unsolved')
      this.statusOptions[1].label = i18n.t('warningPage.Solevd')
      var param = {
        companyIdList: this.selectCompany,
        endDate: new Date(this.oneWeek[1]).getTime(),
        startDate: new Date(this.oneWeek[0]).getTime(),
        delFlag: this.status,
        site: this.site,
        key: this.inputDeviceName,
        msgType: this.inforType || -1,
        pageNum: this.listQuery.pageInfo.pageNum, // 分页--选中某一页
        pageSize: this.listQuery.pageInfo.pageSize // 分页--每一页的列表的行数 10 20 50
      }
      if (this.selectDayWarning && this.selectDayWarning.length > 0) {
        param.startDate = new Date(this.selectDayWarning[0]).setHours(0, 0, 0, 0)
        param.endDate = new Date(this.selectDayWarning[1]).setHours(0, 0, 0, 0) + 24 * 60 * 60 * 1000 - 1000
      }
      this.loading = true
      listWarningPushMsg2(param).then(res => {
        this.loading = false
        // 警告信息列表数据
        if (res.resultCode === 1001) {
          if (!res.resultModel) {
            this.tableData = []
            this.listQuery.pageInfo.total = this.listQuery.pageInfo.pageNum = 0
            return
          }
          this.tableData = res.resultModel.list || []
          this.listQuery.pageInfo.total = res.resultModel.total // 分页
          for (var i = this.tableData.length - 1; i >= 0; i--) {
            var v = this.tableData[i]
            if (v.delFlag == 1) { // 已解决
              var duraS = v.updateTime - v.createTime // 毫秒
              v.warnDuration = duraS < 60 * 1000 ? Math.ceil(duraS / 1000) + this.$t('dataAndTime.Seconds') : usedTime(duraS, 'noSecond')
              v.updateTime = getDateAndHour(v.updateTime, 'noSecond')
              v.status = i18n.t('warningPage.Solevd')
            } else {
              v.warnDuration = usedTime(Date.now() - v.createTime, 'noSecond')
              v.updateTime = '--'
              v.status = i18n.t('warningPage.Unsolved')
            }
            switch (v.workStatus) { // 1充电中、2放电中、3静止中
              case 1:v.WorkStatusZh = i18n.t('allDeviceDetail.Charging'); break
              case 2:v.WorkStatusZh = i18n.t('allDeviceDetail.Discharging'); break
              case 3:v.WorkStatusZh = i18n.t('allDeviceDetail.Idle'); break
              default:v.WorkStatusZh = '--'; break
            }
            if (v.createTime) { v.createTime = getDateAndHour(v.createTime, 'noSecond') }
            if (v.msgType == 1) {
              if (v.triggerValue) {
                v.triggerValue = v.triggerValue > 100 ? Math.round(v.triggerValue / 100) : Math.round(v.triggerValue)
              }
              v.message = i18n.t('warningInfo.batterySocLow1') + v.triggerValue + i18n.t(`warningInfo.batterySocLow2`)
            } else if (v.msgType == 2) {
              v.message = i18n.t('warningInfo.batteryWaterLow')
            } else if (v.msgType == 4 || v.msgType == 11 | v.msgType == 12 || v.msgType == 13) {
              if (v.triggerValue) {
                v.triggerValue = v.triggerValue > 1000 ? Math.round(v.triggerValue / 100) : Math.round(v.triggerValue)
              }
              v.message = i18n.t('warningInfo.batteryTemHeight1') + temChangeUnit(v.triggerValue) + i18n.t('warningInfo.batteryTemHeight2')
            } else if (v.msgType == 5) {
              v.message = i18n.t('warningInfo.batteryCapacity1') + v.triggerValue + i18n.t('warningInfo.batteryCapacity2')
            } else if (v.msgType == 6) {
              v.message = i18n.t('warningInfo.batteryNoPosition')
            } else if (v.msgType == 7) {
              v.message = i18n.t('warningInfo.batteryVoltageLow1') + v.triggerValue + i18n.t('warningInfo.batteryVoltageLow2')
            } else if (v.msgType == 8) {
              v.message = i18n.t('warningInfo.batteryTemLow1') + temChangeUnit(v.triggerValue) + i18n.t('warningInfo.batteryTemLow2')
            } else if (v.msgType == 9) {
              v.message = i18n.t('warningInfo.batteryTemAbnormal')
            } else if (v.msgType == 10) {
              v.message = i18n.t('warningInfo.batteryVoltageHeight1') + v.triggerValue + i18n.t('warningInfo.batteryVoltageHeight2')
            } else if (v.msgType == 15) {
              v.message = i18n.t('warningInfo.HalfVWarn')
            } else if (v.msgType == 16) {
              v.message = i18n.t('warningInfo.offlineWarn').replace('$1', v.triggerValue)
            } else if (v.msgType == 17) {
              v.message = i18n.t('warningInfo.linChargeOverWarn')
            } else if (v.msgType == 18) {
              if (v.triggerValue) { v.triggerValueZh = getDateAndHour(v.triggerValue, 'noTime') }
              v.message = i18n.t('warningInfo.overTiemTo').replace('$1', v.triggerValueZh)
            } else if (v.msgType == 19) {
              v.message = i18n.t('warningInfo.overTiem')
            } else if (v.msgType == 20) {
              v.message = i18n.t('warningSet.chargeDisAbnormalWarn')
            } else if (v.msgType == 21) {
              v.message = i18n.t('warningInfo.unitVLowWarn')
            } else {
              this.tableData.splice(i, 1)
            }
          }
        }
      })
    },
    changeGlobalSearch(val) { // 页面全局搜索
      this.selectCompany = []
      this.selectCompany2.forEach(v => {
        this.selectCompany.push((typeof v === 'string' && v.indexOf('ID') > -1) ? v.slice(2) : v)
      })
      if (val == 'date' && (!this.selectDayWarning || this.selectDayWarning.length == 0)) { // 如果点击清空日期，则默认为一个月
        this.selectDayWarning = [new Date().setHours(0, 0, 0, 0) - 30 * 24 * 60 * 60 * 1000, Date.now()]
      }
      this.queryList()
      this.queryTable()
    },
    tableSearch() { // 表格搜索
      this.listQuery.pageInfo.pageNum = 1
      this.pageshow = false
      this.queryTable()
      this.$nextTick(() => {
        this.pageshow = true
      })
    },
    // 分页----start
    handleSizeChange(val, e) {
      // 每一页的列表的行数 10 20 50
      this.listQuery.pageInfo.pageSize = val
      this.queryTable()
    },
    handleCurrentChange(val, e) {
      // 选中某一页
      this.listQuery.pageInfo.pageNum = val
      this.queryTable()
    },
    // 分页----end
    edit(row) {
      // 编辑
      this.tableEditPopShow = true
      this.tableRow = JSON.parse(JSON.stringify(row))
      // this.tableRow = row
    },
    changeStatus() {
      if (this.tableRow.status == i18n.t('warningPage.Unsolved')) { this.myStatus = 0 }
      if (this.tableRow.status == i18n.t('warningPage.Solevd')) { this.myStatus = 1 }
    },
    submitPop() {
      // 弹窗--提交
      // var myStatus
      console.log(this.tableRow.status)
      if (this.tableRow.status == i18n.t('warningPage.Unsolved') || this.tableRow.status == 0) { this.myStatus = 0 }
      if (this.tableRow.status == i18n.t('warningPage.Solevd') || this.tableRow.status == 1) { this.myStatus = 1 }
      var param = {
        delFlag: this.myStatus,
        id: this.tableRow.id,
        remark: this.tableRow.remark
      }
      switch (param.delFlag) {
        case '未解决':
          param.delFlag = 0
          break
        case '已解决':
          param.delFlag = 1
          break
      }
      updatePushMsgDelFlag(param).then(res => {
        // 弹窗--提交
        if (res.resultCode === 1001) {
          this.tableEditPopShow = false
          this.queryTable()
        }
      })
    },
    goToWarningSet(mcuId) {
      // 去警告配置页
      console.log(mcuId)
      var routeData = this.$router.resolve({
        path: '/warning/warningSet',
        query: {
          mcuId: mcuId
          // mcuId: '05d9ff333432554e43133650'
        }
      })
      window.open(routeData.href, '_self')
      // this.$router.push({ path: '/trionicDetail', query: { mcuId: '05d9ff333432554e43133650' }}) // 暂用--无需校验账号密码--trionic
    },
    download() {
      // 下载
      import('@/vendor/Export2Excel').then(excel => {
        const tHeader = [
          i18n.t('yhubReport.occurredAt'),
          i18n.t('dashboard.DeviceName'),
          i18n.t('warningPage.Content'),
          i18n.t('AllDevices.Status'),
          i18n.t('warningPage.SovledAt'),
          i18n.t('BondOrUpdateDevice.OwnedCompany'),
          i18n.t('warningInfo.AlarmDuration'),
          i18n.t('warningInfo.WorkStatus'),
          i18n.t('warningPage.Remark')
        ]
        const filterVal = [
          'createTime',
          'deviceName',
          'message',
          'status',
          'updateTime',
          'companyName',
          'warnDuration',
          'WorkStatusZh',
          'remark'
        ]
        const list = this.tableData
        const data = this.formatJson(filterVal, list)
        excel.export_json_to_excel({
          header: tHeader,
          data,
          filename: 'warningList',
          autoWidth: true,
          bookType: 'xlsx'
        })
      })
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v =>
        filterVal.map(j => {
          if (j === 'timestamp') {
            return parseTime(v[j])
          } else {
            return v[j]
          }
        })
      )
    },
    download1() {
      // 下载
      var param = {
        accessToken: this.$store.state.token,
        companyIdList: [],
        endDate: new Date(getDateAndHour(new Date().getTime(), 'noTime')).getTime() - 8 * 60 * 60 * 1000, // 结束时间 2019-11-27 -> 时间戳,
        startDate: new Date(getDateAndHour(new Date().getTime() - 70 * 24 * 60 * 60 * 1000, 'noTime')).getTime() - 8 * 60 * 60 * 1000, // 开始时间 2019-11-21 -> 时间戳
        delFlag: this.status || -1,
        key: this.inputDeviceName,
        msgType: this.inforType || -1
      }
      if (this.$store.state.company) { param.companyIdList.push(this.$store.state.company.id) }
      if (this.selectCompany && this.selectCompany.length) {
        param.companyIdList = this.selectCompany
      }
      // console.log(this.selectDayTable)
      if (this.selectDayTable && this.selectDayTable.length > 0) {
        param.startDate = new Date(getDateAndHour(new Date(this.selectDayTable[0]).getTime(), 'noTime')).getTime() - 8 * 60 * 60 * 1000
        param.endDate = new Date(getDateAndHour(new Date(this.selectDayTable[1]).getTime(), 'noTime')).getTime() - 8 * 60 * 60 * 1000
      }
      var url = process.env.VUE_APP_BASE_API + '/v3/report/exportWarningPushMsgCsv'
      url += '?endDate=' + param.endDate + '&mcuId=' + param.mcuId + '&startDate=' + param.startDate + '&accessToken=' + param.accessToken
      window.open(url, '_bank')
    },
    getCity() { // 获取已有的地址
      this.allCity = []
      getCompanySiteList().then(res => {
        if (res.resultCode != 1001 || !res.resultModel) return
        res.resultModel.forEach(v => {
          this.allCity.push({ value: v })
        })
      })
    },
    querySearchCity(queryString, cb) {
      var allCity = this.allCity
      var results = queryString ? allCity.filter(this.createFilter(queryString)) : allCity
      cb(results)
    },
    createFilter(queryString) {
      return (restaurant) => {
        return restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0
      }
    },
    handleSelect(item) {
    }
  }
}
</script>

<style lang="scss">
p {
  margin: 0;
}
.tableSelect {
  width: 10%;
  vertical-align: top;
  padding-left: 5px;
  // padding-right: 10px
}
.searchWarp{
  margin-bottom: 10px;
  .searchBox{
    width:20%;
    max-width: 400px;
    display: inline-block;
  }
  .dateBox{
    width:30%;
    .el-date-editor{
      width:100%;
    }
  }
}
#warning .el-table th {
  text-align: center;
}
</style>

